'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketingBannerWrapper = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _RewardsBanner = require('acq-components/lib/composite-components/Banner/Variations/RewardsBanner');

var _marketingBanner = require('../../../utils/component-content-generation/marketingBanner');

var _marketingBanner2 = require('../../../redux/selectors/marketingBanner');

var selectors = _interopRequireWildcard(_marketingBanner2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarketingBannerWrapper = function MarketingBannerWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      shadeAlternator = _ref.shadeAlternator,
      namespace = _ref.namespace,
      _ref$titleComponent = _ref.titleComponent,
      titleComponent = _ref$titleComponent === undefined ? 'h2' : _ref$titleComponent,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === undefined ? 'right' : _ref$alignment,
      _ref$useMarginTop = _ref.useMarginTop,
      useMarginTop = _ref$useMarginTop === undefined ? true : _ref$useMarginTop,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'shadeAlternator', 'namespace', 'titleComponent', 'alignment', 'useMarginTop']);

  if (!props.title) return null;

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded(),
      style: useMarginTop && { marginTop: '20px' }
    },
    _react2.default.createElement(
      _RewardsBanner.RewardsBanner,
      {
        styles: styles.rewardsBanner,
        titleComponent: titleComponent,
        title: props.title,
        secondaryHeadline: props.secondaryHeadline,
        background: props.background,
        alignment: alignment,
        namespace: props.namespace,
        qeId: props.qeId
      },
      Array.isArray(props.content) && _react2.default.createElement(_marketingBanner.MarketingBannerChildren, { content: props.content, styles: styles }),
      !!props.listItems.length && _react2.default.createElement(_marketingBanner.MarketingBannerList, { listItems: props.listItems, styles: styles })
    )
  );
};

exports.MarketingBannerWrapper = MarketingBannerWrapper;
var mapStateToProps = function mapStateToProps(state) {
  return {
    secondaryHeadline: selectors.getSecondaryHeadline(state),
    title: selectors.getHeader(state),
    background: selectors.getBackground(state),
    content: selectors.getContent(state),
    listItems: selectors.getListItems(state),
    qeId: selectors.getQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MarketingBannerWrapper);